"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTaxConfig = exports.deleteTaxConfig = exports.createTaxConfig = exports.getTaxConfigById = exports.getAllTaxConfigs = exports.getCursorPaginatedTaxConfigs = void 0;
const shared_1 = require("@getgreenline/shared");
const getCursorPaginatedTaxConfigs = async (companyId, filter) => {
    const response = await shared_1.axios.get(`/api/v1/companies/${companyId}/tax-configs`, {
        params: {
            ...filter,
        },
    });
    return response.data;
};
exports.getCursorPaginatedTaxConfigs = getCursorPaginatedTaxConfigs;
const getAllTaxConfigs = async (companyId) => {
    const response = await shared_1.axios.get(`/api/v1/companies/${companyId}/tax-configs/all`);
    return response.data;
};
exports.getAllTaxConfigs = getAllTaxConfigs;
const getTaxConfigById = async (companyId, taxConfigId) => {
    const response = await shared_1.axios.get(`/api/v1/companies/${companyId}/tax-configs/${taxConfigId}`);
    return response.data;
};
exports.getTaxConfigById = getTaxConfigById;
const createTaxConfig = async (companyId, taxConfig) => {
    const response = await shared_1.axios.post(`/api/v1/companies/${companyId}/tax-configs`, taxConfig);
    return response.data;
};
exports.createTaxConfig = createTaxConfig;
const deleteTaxConfig = async (companyId, taxConfigId) => {
    return shared_1.axios.delete(`/api/v1/companies/${companyId}/tax-configs/${taxConfigId}`);
};
exports.deleteTaxConfig = deleteTaxConfig;
const updateTaxConfig = async (companyId, taxConfigId, taxConfig) => {
    const response = await shared_1.axios.put(`/api/v1/companies/${companyId}/tax-configs/${taxConfigId}`, taxConfig);
    return response.data;
};
exports.updateTaxConfig = updateTaxConfig;
//# sourceMappingURL=taxConfigApi.js.map